import { BaseEditor, Editor, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { CustomElement } from "../slate";

export interface BlocksEditor extends BaseEditor {
  isCodeBlock: () => boolean;
  toggleCodeBlock: () => void;
  isBlockQuote: () => boolean;
  toggleBlockQuote: () => void;
  insertHorizontalLine: () => void;
}

const isCodeBlock = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) => n.type === "code-block",
  });
  return !!match;
};

const toggleCodeBlock = (editor: Editor) => {
  const isActive = isCodeBlock(editor);

  Transforms.setNodes(editor, { type: isActive ? "paragraph" : "code-block" });
  ReactEditor.focus(editor);
};

const isBlockQuote = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) => n.type === "block-quote",
  });
  return !!match;
};

const toggleBlockQuote = (editor: Editor) => {
  const isActive = isBlockQuote(editor);

  Transforms.setNodes(editor, { type: isActive ? "paragraph" : "block-quote" });
  ReactEditor.focus(editor);
};

const insertHorizontalLine = (editor: Editor) => {
  Transforms.insertFragment(editor, [
    { type: "hr", children: [] },
    { type: "paragraph", children: [{ text: "" }] },
  ]);
  ReactEditor.focus(editor);
};

export const withBlocks = (editor: Editor) => {
  const { isVoid } = editor;
  editor.isVoid = (element: CustomElement) => {
    return element.type === "hr" ? true : isVoid(element);
  };
  editor.isCodeBlock = () => isCodeBlock(editor);
  editor.toggleCodeBlock = () => toggleCodeBlock(editor);
  editor.isBlockQuote = () => isBlockQuote(editor);
  editor.toggleBlockQuote = () => toggleBlockQuote(editor);
  editor.insertHorizontalLine = () => insertHorizontalLine(editor);
  return editor;
};
